export const COLLECTIONS = [
  {
    key: 'rocagres',
    label: 'Rocagres',
    tagline: 'Premium Porcelain & Wood-Look Tile',
    description:
      'The Rocagres collection brings together precision-engineered porcelain and warmly textured wood-look planks — spanning 12×24 to 48×72 large-format slabs. Every piece is designed and manufactured to exacting standards, delivering exceptional consistency in colour, dimension, and finish.',
  },
];

export const DEFAULT_COLLECTION = 'rocagres';
